export const state = () => ({
    scrollY: 0,
    windowWidth: 0,
    prevWindowWidth: 0,
    isSearchDropdownOpen: false,
    isMobileMenuOpen: false,
    isHeaderThin: false,
    isPageLoading: true,
    isLoginModalOpen: false,
    isRegistrationModalOpen: false,
    lastScrollDirection: 'down',
    notifications: [],
    editable_options: [
        {
            id: 1,
            name: 'frame',
            options: [
                {
                    id: 1,
                    name: 'products.frame.black',
                    preview: 'frame_1.webp',
                    color: '#00000',
                    image: '',
                    price: 0,
                },
                {
                    id: 2,
                    name: 'products.frame.white',
                    preview: 'frame_2.webp',
                    color: '#ffffff',
                    image: '',
                    price: 0,
                },
                /* {
                    id: 3,
                    name: 'Fa  (Tölgy)',
                    preview: 'frame_3.webp',
                    color: '#ffffff',
                    image: '',
                    price: 2000,
                }, */
                {
                    id: 3,
                    name: 'products.frame.none',
                    preview: '',
                    color: '#ffffff',
                    image: '',
                    price: 0,
                },
            ],
        },
        {
            id: 2,
            name: 'size',
            options: [
                {
                    id: 1,
                    name: '30*40cm',
                    width: 30,
                    height: 40,
                    preview: '',
                },
                {
                    id: 2,
                    name: '40*50cm',
                    width: 40,
                    height: 50,
                    price: 4500,
                    preview: '',
                },
                {
                    id: 3,
                    name: '50*70cm',
                    width: 50,
                    height: 70,
                    price: 5000,
                    preview: '',
                },
                {
                    id: 4,
                    name: '60*90cm',
                    width: 60,
                    height: 90,
                    price: 6500,
                    preview: '',
                },
            ],
        },
    ],
});

export const getters = {
    getWindowWidth(state) {
        return state.windowWidth;
    },
};

export const mutations = {
    setScrollY(state, payload) {
        state.scrollY = payload;
    },
    setHeaderThin(state, payload) {
        state.isHeaderThin = payload;
    },
    setWindowWidth(state, payload) {
        state.windowWidth = payload;
    },
    setLastScrollDirection(state, payload) {
        state.lastScrollDirection = payload;
    },
    toggleLoginModal(state, payload) {
        state.isLoginModalOpen = payload;
    },
    toggleRegistrationModal(state, payload) {
        state.isRegistrationModalOpen = payload;
    },
    setIsPageLoading(state, payload) {
        state.isPageLoading = payload;
    },
    setNotifications(state, payload) {
        state.notifications.push(payload);
    },
    emptyNotifications(state) {
        state.notifications = [];
    },
    toggleSearchDropdown(state, payload) {
        state.isSearchDropdownOpen = payload;
    },
    toggleMobileMenu(state, payload) {
        state.isMobileMenuOpen = payload;
    },
    setPrevWindowWidth(state, payload) {
        state.prevWindowWidth = payload;
    },
};
